namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailExterniSystem extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GExterniSystemReadDto;
        private newRecord: boolean;
        private detailObj: DetailExterniSystemObj & GContent;
        private typy_ess: {nazev: string }[];
        private verze_ess: { nazev: string }[];
        private mutace_ess: { nazev: string }[];
        private currentIco: string;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailExterniSystemObj());
            this.detailObj.createBase({
                contentName: "detailExterniSystem",
                contentCaption: "jres:33000266", //RC 33000266 : Externí systém
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            this.detailObj.typy_ess = this.typy_ess;
            this.detailObj.verze_ess = this.verze_ess;
            this.detailObj.mutace_ess = this.mutace_ess;
            this.detailObj.currentIco = this.currentIco;
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            this.detailObj.setSpecialTabs(tabs);
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            this.detailObj.setSpecialGroups(groups);
            builder.withComponent<this>("DetailExterniSystem", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailExterniSystemObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GExterniSystemReadDto> {
        public typy_ess: { nazev: string }[];
        public verze_ess: { nazev: string }[];
        public mutace_ess: { nazev: string }[];
        public currentIco: string;
        public serviceCnt: GContent;
        public gridCertificate: JQuery<HTMLElement>;
        public gridNavazaneInstance: JQuery<HTMLElement>;
        public gridPrenaset: JQuery<HTMLElement>;
        public gridAvizace: JQuery<HTMLElement>;
        public gridPredavat: JQuery<HTMLElement>;
        public gridExterniUzivatele: JQuery<HTMLElement>;

        private povolenePrenasetAvizacePredani(): boolean {
            if (this.options.newRecord == false) {
                if (this.data.priz_ess != 0)
                    return true;
            }
            return false;
        }

        getServiceCnt(): GContent {
            if (this.serviceCnt == null || this.serviceCnt == undefined)
                this.serviceCnt = this.cnt.createServiceContent("Gordic.Adm.WebControls.DetailExterniSystem")
            return this.serviceCnt;
        }

        create() {
            if (this.options.newRecord == false) {
                if (this.data["ico"] != this.currentIco)
                    this.cnt.showFlash({
                        content: "jres:33000270".format(this.currentIco), //RC 33000270 : Pozor! Při případné editaci se IČO tohoto záznamu nastaví na aktuálně přihlášené IČO ({0})
                        state: "warning",
                        icon: "fa-exclamation-triangle"
                    })
            }
        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return (this.data.ixs_ext) ? this.data.ixs_ext : "";
        }

        saveData(data: Gordic.AdmIsl.Interface.GExterniSystemSaveDto, close: boolean) {
            data.certificates = this.gridCertificate ? this.gridCertificate.ggrid("getView").getDataRows(false, "data") : (this.data.certificates ? this.data.certificates : []);
            if (data.priz_ess != 0) {
                data.prenasetTypyDokumentu = this.gridPrenaset ? this.gridPrenaset.ggrid("getView").getDataRows(false, "data") : (this.data.prenasetTypyDokumentu ? this.data.prenasetTypyDokumentu : []);
                data.avizaceTypyDokumentu = this.gridAvizace ? this.gridAvizace.ggrid("getView").getDataRows(false, "data") : (this.data.avizaceTypyDokumentu ? this.data.avizaceTypyDokumentu : []);
                data.predavatTypyDokumentu = this.gridPredavat ? this.gridPredavat.ggrid("getView").getDataRows(false, "data") : (this.data.predavatTypyDokumentu ? this.data.predavatTypyDokumentu : []);
            }
            data.externiUzivatele = this.gridExterniUzivatele ? this.gridExterniUzivatele.ggrid("getView").getDataRows(false, "data") : (this.data.externiUzivatele ? this.data.externiUzivatele : []);
            (this.cnt.isl.ExterniSystem.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                if (err.responseJSON.exception.containsNonFatal != true)
                    this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailExterniSystem", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.ExterniSystem.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                //  Přihlašovací certifikáty
                actAddLoginCertificates: {
                    caption: "jres:33000248",
                    icon: "gi-plus",
                    enabled: false,
                    run: (ev, ctx) => {
                        this.addLoginCertificate();
                    }
                },
                actUpdateLoginCertificates: {
                    caption: "jres:32000120",
                    icon: "gi-pencil",
                    enabled: false,
                    run: (ev, ctx) => {
                        this.updateLoginCertificates();
                    }
                },
                actRemoveLoginCertificates: {
                    caption: "jres:33000272", //RC 33000272 : Odebrat
                    icon: "gi-minus",
                    enabled: false,
                    run: (ev, ctx) => {
                        this.removeLoginCertificates();
                    }
                },
                // Přenášet
                actUpdatePrenaset: {
                    caption: "jres:32000120",
                    icon: "gi-pencil",
                    enabled: false,
                    run: (ev, ctx) => {
                        this.updatePrenaset();
                    }
                },
                // Avizace
                actUpdateAvizace: {
                    caption: "jres:32000120",
                    icon: "gi-pencil",
                    enabled: false,
                    run: (ev, ctx) => {
                        this.updateAvizace();
                    }
                },
                // Predavani
                actUpdatePredavat: {
                    caption: "jres:32000120",
                    icon: "gi-pencil",
                    enabled: false,
                    run: (ev, ctx) => {
                        this.updatePredavat();
                    }
                },
                // Externi uzivatele
                actUpdateExterniUzivatele: {
                    caption: "jres:32000120",
                    icon: "gi-pencil",
                    enabled: false,
                    run: (ev, ctx) => {
                        this.updatePassword(ev);
                    }
                },
                actUpdateExterniUzivateleOk: {
                    caption: "jres:33000243",
                    customClass: "g-button--primary",
                    run: (ev, ctx) => {
                        this.updatePasswordOk(ev, ctx);
                    }
                },
                actUpdateExterniUzivateleCancel: {
                    caption: "jres:32131042",
                    run: (ev, ctx) => {
                        $.content(ev.target).close()
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {
            this.cnt.actions.actAddLoginCertificates?.update({ enabled: editMode })
            this.cnt.actions.actRemoveLoginCertificates?.update({ enabled: editMode })
            this.cnt.actions.actUpdateLoginCertificates?.update({ enabled: editMode })
            this.cnt.actions.actUpdatePrenaset?.update({ enabled: editMode })
            this.cnt.actions.actUpdateAvizace?.update({ enabled: editMode })
            this.cnt.actions.actUpdatePredavat?.update({ enabled: editMode })
            this.cnt.actions.actUpdateExterniUzivatele?.update({ enabled: editMode })
            this.cnt.findFields("zkratka").gfield(this.data.priz_create_ag == 1 && this.options.newRecord == true ? "enable" : "disable");
        }

        createForm() {
            var _this = this;
            this.MakeField("ico", { flag: this.createFlagNemenne() });
            this.MakeField("ixs_ext", { flag: this.createFlagNemenne() });
            this.MakeField("nazev");
            this.MakeField("poznamka");
            this.MakeField("mail_chyby");
            this.MakeSelectField("priz_no_is", Gordic.Prefabs.Select.gincpan(), {
                model: function (op, dto, opt) {
                    switch (op) {
                        case "apply":
                            if (dto.priz_no_is != null && dto.priz_no_is != undefined) {
                                $(this).gfield("setValue", { priz_an: dto["priz_no_is"] == 0 ? 1 : 0 }, { valid: false })
                            }
                            break;
                        case "collect":
                            var data = $(this).gfield("getValue");
                            if (data != null)
                                dto["priz_no_is"] = data.priz_an == 1 ? 0 : 1
                            else
                                dto["priz_no_is"] = 0
                            break;
                    }
                }
            })
            this.MakeSelectField("priz_ruc_pre_do_ea", Gordic.Prefabs.Select.gincpan(), {
                model: "model.priz_ruc_pre_do_ea=value.priz_an",
                change: (ev, ctx) => {
                    if (ctx.value) {
                        if (!Array.isArray(ctx.value)) {
                            if (ctx.value.priz_an == 0)
                                _this.cnt.findFormRows("row_ixs_fun_zodp").hide();
                            else
                                _this.cnt.findFormRows("row_ixs_fun_zodp").show();
                        }
                    }
                }
            })
            this.MakeSelectField("priz_ess", Gordic.Prefabs.Select.intcpes(), {
                flag: this.createFlagNemenne(),
                model: "model.priz_ess=value.priz_ess",
                change: (ev, ctx) => {
                    if (ctx.value) {
                        if (!Array.isArray(ctx.value)) {
                            this.cnt.hideFlash("externi-system-info");
                            this.cnt.findFormRows("row_url_ws1", "row_typ_ess", "row_verze_ess", "row_mutace_ess", "row_ur_pri", "row_typ_ag_ext", "row_id_nss", "row_id_nss_this", "row_url_ws2", "row_url_ws2", "row_url_ws3", "row_priz_create_ag", "row_zkratka").show();
                            switch (ctx.value.priz_ess) {
                                case 0:
                                    this.cnt.findFormRows("row_url_ws1", "row_typ_ess", "row_verze_ess", "row_mutace_ess", "row_ur_pri", "row_typ_ag_ext", "row_id_nss", "row_id_nss_this", "row_url_ws2", "row_url_ws3").hide();
                                    break;
                                case 1:
                                    this.cnt.findFormRows("row_priz_create_ag", "row_zkratka").hide();
                                    this.cnt.showFlash({
                                        content: "jres:33000267", //RC 33000267 : Systém typu ESS komunikující přes RSS.
                                        state: "info",
                                        icon: "gi-info_bold",
                                        id: "externi-system-info"
                                    })
                                    break;
                                case 2:
                                    this.cnt.findFormRows("row_priz_create_ag", "row_zkratka").hide();
                                    this.cnt.showFlash({
                                        content: "jres:33000268", //RC 33000268 : Systém typu AIS komunikující přes RŽP/ESS.
                                        state: "info",
                                        icon: "gi-info_bold",
                                        id: "externi-system-info"
                                    })
                                    break;
                                case 3:
                                    this.cnt.findFormRows("row_priz_create_ag", "row_zkratka").hide();
                                    this.cnt.findFormRows("row_url_ws1").hide();
                                    this.cnt.findFormRows("row_url_ws2").hide();
                                    this.cnt.findFormRows("row_url_ws3").hide();
                                    this.cnt.showFlash({
                                        content: "jres:33000269", //RC 33000269 : ERMS systém komunikující dávkově podle NS přes GSAESS01.
                                        state: "info",
                                        icon: "gi-info_bold",
                                        id: "externi-system-info"
                                    })
                                    break;
                            }
                        }
                    }
                }
            })
            this.MakeBoolField("priz_create_ag", {
                change: (ev, ctx) => {
                    if (this.editMode == true && this.options.newRecord == true)
                       this.cnt.findFields("zkratka").gfield(ctx.value == true ? "enable" : "disable");
                }
            })
            this.MakeField("zkratka", {
                flag: this.createFlagNemenne(),
                validators: [new Gordic.Validators.Length({ min: 0, max: 3 })]
            });
            this.MakeField("url_ws1");
            this.MakeSelectField("typ_ess", {}, {
                data: this.typy_ess,
                dropdown: true,
                model: function (op, dto, opt) {
                    switch (op) {
                        case "apply":
                            if (dto.typ_ess) {
                                var selected = _this.typy_ess.filter(obj => obj.nazev == dto.typ_ess)[0];
                                $(this).gfield("setValue", selected);
                            }
                            break;
                        case "collect":
                            var typ_ess = $(this).gfield("getValue");
                            if (typ_ess != null && typ_ess != undefined)
                                dto["typ_ess"] = typ_ess["nazev"];
                            break;
                    }
                },
                itemTemplate: "{nazev}"
            })
            this.MakeSelectField("verze_ess", {}, {
                data: this.verze_ess,
                dropdown: true,
                model: function (op, dto, opt) {
                    switch (op) {
                        case "apply":
                            if (dto.verze_ess) {
                                var selected = _this.verze_ess.filter(obj => obj.nazev == dto.verze_ess)[0];
                                $(this).gfield("setValue", selected);
                            }
                            break;
                        case "collect":
                            var verze_ess = $(this).gfield("getValue");
                            if (verze_ess != null && verze_ess != undefined)
                                dto["typ_ess"] = verze_ess["nazev"];
                            break;
                    }
                },
                itemTemplate: "{nazev}"
            })
            this.MakeSelectField("mutace_ess", {}, {
                data: this.mutace_ess,
                dropdown: true,
                model: function (op, dto, opt) {
                    switch (op) {
                        case "apply":
                            if (dto.mutace_ess) {
                                var selected = _this.mutace_ess.filter(obj => obj.nazev == dto.mutace_ess);
                                if (selected.length > 0)
                                   $(this).gfield("setValue", selected[0]);
                            }
                            if (_this.options.newRecord == true)
                                $(this).gfield("setValue", _this.mutace_ess[3]);
                            break;
                        case "collect":
                            var mutace_ess = $(this).gfield("getValue");
                            if (mutace_ess != null && mutace_ess != undefined)
                                dto["mutace_ess"] = mutace_ess["nazev"];
                            break;
                    }
                },
                itemTemplate: "{nazev}"
            });
            this.MakeField("ur_pri");
            this.MakeField("typ_ag_ext")
            this.MakeField("id_nss");
            this.MakeField("id_nss_this");
            this.MakeSelectField("ixs_fun_zodp", Gordic.Prefabs.Select.ginsfun(), {
                model: "model.ixs_fun_zodp=value.ixs_fun"
            })
            this.MakeField("url_ws2");
            this.MakeField("url_ws3");
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt())
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" })
            this.MakeField("dat_zmena");
        }

        // speciální tabs 
        setSpecialTabs(tabs: Gordic.Gin.DetailBuilder.TabParamsId[]) {
            tabs.push({
                tabParams: {
                    id: "tab-cerficate",
                    title: (this.data.ixs_ext == "0000AIE00006") ? "jres:33000275" : "jres:33000271", //RC 33000275 : Systémové certifikáty
                    opened: true,
                    locked: true,
                    group: { id: "_tab-certificate" },
                    menuBar: [
                        {
                            action: this.cnt.actions.actAddLoginCertificates,
                            favorite: true
                        },
                        {
                            action: this.cnt.actions.actRemoveLoginCertificates,
                            favorite: true
                        },
                        {
                            action: this.cnt.actions.actUpdateLoginCertificates,
                            favorite: true
                        }
                    ],
                },
                init: (tab) => { this.createCertificateGrid(tab); }
            })
            tabs.push({
                tabParams: {
                    id: "tab-navazane-instance",
                    title: (this.data.ixs_ext == "0000AIE00006") ? "jres:33000275" : "jres:33000271", //RC 33000273 : Navázané instance
                    opened: true,
                    locked: true,
                    group: { id: "_tab-navazane-instance" },
                },
                init: (tab) => { this.createNavazaneinstanceGrid(tab); }
            })
            if (this.data.priz_no_is != 1) {
                tabs.push({
                    tabParams: {
                        id: "tab-externi-uzivatele",
                        title: "jres:33000283",
                        opened: true,
                        locked: true,
                        group: { id: "_tab-externi-uzivatele" },
                        menuBar: [
                            {
                                action: this.cnt.actions.actUpdateExterniUzivatele,
                                favorite: true
                            }
                        ]
                    },
                    init: (tab) => { this.createExterniUzivateleTab(tab); }
                })
            }
            if (this.povolenePrenasetAvizacePredani() == true) {
                tabs.push({
                    tabParams: {
                        id: "tab-prenaset",
                        title: "jres:33000277", //RC 33000277 : Seznam typů dokumentů přenášených automaticky přes rozhraní dle NS z EKO do eSSL
                        opened: true,
                        locked: true,
                        group: { id: "_tab-prenaset" },
                        menuBar: [
                            {
                                action: this.cnt.actions.actUpdatePrenaset,
                                favorite: true
                            }
                        ]
                    },
                    init: (tab) => { this.createPrenasetTab(tab); }
                })
                tabs.push({
                    tabParams: {
                        id: "tab-avizace",
                        title: "jres:33000279", //RC 33000279 : Seznam typů dokumentů povolených v aplikacích pro avizace do ext. systému
                        opened: true,
                        locked: true,
                        group: { id: "_tab-avizace" },
                        menuBar: [
                            {
                                action: this.cnt.actions.actUpdateAvizace,
                                favorite: true
                            }
                        ]
                    },
                    init: (tab) => { this.createAvizaceTab(tab); }
                })
                tabs.push({
                    tabParams: {
                        id: "tab-predavat",
                        title: "jres:33000282", //RC 33000282 : Seznam typů dokumentů povolených v aplikacích pro předání do ext. systému
                        opened: true,
                        locked: true,
                        group: { id: "_tab-predavat" },
                        menuBar: [
                            {
                                action: this.cnt.actions.actUpdatePredavat,
                                favorite: true
                            }
                        ]
                    },
                    init: (tab) => { this.createPredavatTab(tab); }
                })
            }
        }

        setSpecialGroups(groups: IGTabGroupOptions[]) {
            groups.push({
                id: "_tab-certificate",
                caption: (this.data.ixs_ext == "0000AIE00006") ? "jres:33000275" : "jres:33000271"
            })
            groups.push({
                id: "_tab-navazane-instance",
                caption: "jres:33000273"
            })
            if (this.data.priz_no_is != 1) {
                groups.push({
                    id: "_tab-externi-uzivatele",
                    caption: "jres:33000283" //RC 33000283 : Účty ext. uživatelů
                })
            }
            if (this.povolenePrenasetAvizacePredani() == true) {
                groups.push({
                    id: "_tab-prenaset",
                    caption: "jres:33000276"
                })
                groups.push({
                    id: "_tab-avizace",
                    caption: "jres:33000280" //RC 33000280 : Avizace
                })
                groups.push({
                    id: "_tab-predavat",
                    caption: "jres:33000281" //RC 33000281 : Předávat
                })
            }
        }

        // Přihlašovací certifikáty
        private createCertificateGrid(tab: JQuery<HTMLElement>) {
            this.gridCertificate = $("<div>").appendTo(tab).gautofit({ resizersOnTab: false }).ggrid({
                columns: new Gordic.Data.GridFormat()
                    .addTextColumn({
                        name: "nazev_cer",
                        caption: "jres:30027574",
                        editor: {
                            widget: "gselectbox",
                            options: $.extend(Gordic.Prefabs.Select.admWflscer(), {
                                serverFilters: {
                                    priz_int: 1,
                                },
                                name: "ixs_cer",
                                dropdown: true,
                                model: "model.ixs_cer=value.ixs_cer;model.nazev_cer=value.jmeno",
                                validators: [new Gordic.Validators.Required({ stopping: true })]
                            })
                        }
                    })
                    .addTextColumn({
                        name: "poznamka",
                        caption: "jres:29930689",
                        editor: {
                            widget: "gstringbox",
                            options: {
                                name: "poznamka",
                            }
                        }
                    })
            }).ggridroweditor({
                beforeStart: (ev, info: any) => {
                    if (this.editMode == false)
                        ev.preventDefault();
                },
                start: (ev, info) => {
                    if (info.cellInfo.data.ixs_cer)
                        this.cnt.findFields("ixs_cer").gfield("disable");
                },
                beforeCommit: (ev, info) => {
                    var currentIxsCers = this.gridCertificate.ggrid("getView").getDataRows(false).map(x => x.ixs_cer);
                    if (info.cellInfo.meta.newRow == false) {
                        if (this.cnt.findFields("ixs_cer").gfield("getValue")) {
                            var ixs_cer = this.cnt.findFields("ixs_cer").gfield("getValue").ixs_cer;
                            if (currentIxsCers.includes(ixs_cer) == true)
                                ev.preventDefault();
                        } else {
                            ev.preventDefault();
                        }
                    }
                }
            })
            if (this.data.certificates)
               this.gridCertificate.ggrid("setData", this.data.certificates);
        }

        private addLoginCertificate() {
            this.gridCertificate.ggridroweditor("addRow", { aktivita: 100 })
        }

        private updateLoginCertificates() {
            var selected = this.gridCertificate.ggrid("getSelection");
            if (selected.length > 0)
               this.gridCertificate.ggridroweditor("start");
        }

        private removeLoginCertificates() {
            var selected = this.gridCertificate.ggrid("getSelection");
            if (selected.length > 0) {
                var certificates = this.gridCertificate.ggrid("getView").getDataRows(false, "data");
                var index = certificates.findIndex(e => e.ixs_cer == selected[0].ixs_cer);
                if (index != -1)
                    certificates.splice(index, 1);
                this.gridCertificate.ggrid("setData", certificates);
            }
        }

        // Navázané instance tab
        private createNavazaneinstanceGrid(tab) {
            this.gridNavazaneInstance = $("<div>").appendTo(tab).gautofit({ resizersOnTab: false }).ggrid({
                columns: new Gordic.Data.GridFormat()
                    .addTextColumn({
                        caption: "jres:32131111",
                        name: "faze"
                    })
                    .addNumberColumn({
                        caption: "jres:33000274", //RC 33000274 : Typ agendy
                        name: "typ_ag_ext"
                    })
                    .addTextColumn({
                        caption: "jres:32131029",
                        name: "nazev"
                    })
            })
            if (this.data.navazaneInstance)
                this.gridNavazaneInstance.ggrid("setData", this.data.navazaneInstance);
        }

        // Přenášet tab

        private updatePrenaset() {
            var selected = this.gridPrenaset.ggrid("getSelection");
            if (selected.length > 0)
                this.gridPrenaset.ggridroweditor("start");
        }

        private createPrenasetTab(tab) {
            this.gridPrenaset = $("<div>").appendTo(tab).gautofit({ resizersOnTab: false }).ggrid({
                columns: new Gordic.Data.GridFormat()
                    .addTextColumn({
                        caption: "jres:33000278", //RC 33000278 : Typ písemnosti
                        name: "nazev"
                    })
                    .addTextColumn({
                        caption: "jres:32131030",
                        name: "aktivita_txt",
                        editor: {
                            widget: "gselectbox",
                            options: $.extend(Gordic.Prefabs.Select.gincakt(), {
                                name: "aktivita",
                                model: "model.aktivita=value.aktivita;model.aktivita_txt=value.aktivita_txt",
                                dropdown: true,
                                validators: [new Gordic.Validators.Required({ stopping: true })]
                            })
                        }
                    })
            }).ggridroweditor({
                beforeStart: (ev, info: any) => {
                    if (this.editMode == false)
                        ev.preventDefault();
                }
            })
            if (this.data.prenasetTypyDokumentu)
               this.gridPrenaset.ggrid("setData", this.data.prenasetTypyDokumentu);
        }

        // Avizace tab

        private createAvizaceTab(tab) {
            this.gridAvizace = $("<div>").appendTo(tab).gautofit({ resizersOnTab: false }).ggrid({
                columns: new Gordic.Data.GridFormat()
                    .addTextColumn({
                        caption: "jres:33000278", //RC 33000278 : Typ písemnosti
                        name: "nazev"
                    })
                    .addTextColumn({
                        caption: "jres:32131030",
                        name: "aktivita_txt",
                        editor: {
                            widget: "gselectbox",
                            options: $.extend(Gordic.Prefabs.Select.gincakt(), {
                                name: "aktivita",
                                model: "model.aktivita=value.aktivita;model.aktivita_txt=value.aktivita_txt",
                                dropdown: true,
                                validators: [new Gordic.Validators.Required({ stopping: true })]
                            })
                        }
                    })
            }).ggridroweditor({
                beforeStart: (ev, info: any) => {
                    if (this.editMode == false)
                        ev.preventDefault();
                }
            })
            if (this.data.avizaceTypyDokumentu)
                this.gridAvizace.ggrid("setData", this.data.avizaceTypyDokumentu);
        }

        private updateAvizace() {
            var selected = this.gridAvizace.ggrid("getSelection");
            if (selected.length > 0)
                this.gridAvizace.ggridroweditor("start");
        }

        // Prenaseni

        private createPredavatTab(tab) {
            this.gridPredavat = $("<div>").appendTo(tab).gautofit({ resizersOnTab: true }).ggrid({
                columns: new Gordic.Data.GridFormat()
                    .addTextColumn({
                        caption: "jres:33000278", //RC 33000278 : Typ písemnosti
                        name: "nazev"
                    })
                    .addTextColumn({
                        caption: "jres:32131030",
                        name: "aktivita_txt",
                        editor: {
                            widget: "gselectbox",
                            options: $.extend(Gordic.Prefabs.Select.gincakt(), {
                                name: "aktivita",
                                model: "model.aktivita=value.aktivita;model.aktivita_txt=value.aktivita_txt",
                                dropdown: true,
                                validators: [new Gordic.Validators.Required({ stopping: true })]
                            })
                        }
                    })
            }).ggridroweditor({
                beforeStart: (ev, info: any) => {
                    if (this.editMode == false)
                        ev.preventDefault();
                }
            })
            if (this.data.predavatTypyDokumentu)
               this.gridPredavat.ggrid("setData", this.data.predavatTypyDokumentu);
        }

        private updatePredavat() {
            var selected = this.gridPredavat.ggrid("getSelection");
            if (selected.length > 0)
                this.gridPredavat.ggridroweditor("start");
        }

        //Externi uzivatele 

        private externiUzivateleForm(data: any) {
            var form = new Gordic.Forms.Form({ name: "form-passwd" })
                .addRow("jres:33000286").addField("gstringbox", {
                    name: "ldb",
                    disabled: true
                })
                .addRow("jres:30028702").addField("gstringbox", Gordic.Prefabs.GStringBox.password({
                    obslouzilJsemSbiraniHodnotZPolicekTakAbyNemohlNastatProblemSNeaktualnimSifrovacimKlicem: true
                }), {
                    name: "new_passwd",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })
                .addRow("jres:29931137").addField("gdatebox", {
                    name: "dat_do",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })
                .addRow("jres:32131030").addField("gselectbox", Gordic.Prefabs.Select.gincakt(), {
                    name: "aktivita",
                    dropdown: true,
                    model: "model.aktivita=value.aktivita;model.aktivita_txt=value.aktivita_txt",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })

            this.cnt.dialogs.simpleForm("jres:29931171", form, data, {
                width: 600,
                height: 300,
                commandBar: [
                    {
                        actionContext: { data: data },
                        action: this.cnt.actions.actUpdateExterniUzivateleOk
                    },
                    {
                        action: this.cnt.actions.actUpdateExterniUzivateleCancel
                    }
                ]
            })
        }

        private updatePassword(ev) {
            if (this.editMode == false)
                ev.preventDefault();
            else {
                var selected = this.gridExterniUzivatele.ggrid("getSelection");
                if (selected.length > 0)
                    this.externiUzivateleForm(selected[0]);
            }
        }

        private updatePasswordOk(ev, ctx) {
            var cnt = $.content(ev.target);
            var form = cnt.findForms("form-passwd");
            return Prefabs.GStringBox.updateChiperPublicKeys(form).then(() => {
                form.findFields().gfield("model", "collect", ctx.data, {})
                ctx.data.new_password = ctx.data.new_passwd;
                this.getServiceCnt().call("UpdatePasswd", { data: ctx.data }).done((o) => {
                    o.pdb = "****";
                    var currentDataView = this.gridExterniUzivatele.ggrid("getView").getDataRows(false, "data");
                    var index = currentDataView.findIndex(i => i.ldb == o.ldb);
                    if (index != -1) {
                        currentDataView[index].pdb = o.pdb;
                        currentDataView[index].new_password = o.new_password;
                        currentDataView[index].dat_do = o.dat_do;
                        currentDataView[index].aktivita_txt = o.aktivita_txt;
                        currentDataView[index].aktivita = o.aktivita;
                    }
                    cnt.close();
                    this.gridExterniUzivatele.ggrid("setData", currentDataView);
                })
            })
        }

        private createExterniUzivateleTab(tab) {
            //var passwd: string = "";
            this.gridExterniUzivatele = $("<div>").appendTo(tab).gautofit({ resizersOnTab: true }).ggrid({
                defaultAction: this.cnt.actions.actUpdateExterniUzivatele,
                columns: new Gordic.Data.GridFormat()
                    .addTextColumn({
                        caption: "jres:33000284", //RC 33000284 : Referent
                        name: "ixs_ref_txt"
                    })
                    .addTextColumn({
                        caption: "jres:33000285", //RC 33000285 : Login
                        name: "login_ext",
                    })
                    .addTextColumn({
                        caption: "jres:33000286", //RC 33000286 : Login referenta do fáze
                        name: "ldb"
                    })
                    .addTextColumn({
                        caption: "jres:30028702",
                        name: "pdb",
                        //editor: {
                        //    widget: "gstringbox",
                        //    options: $.extend(Gordic.Prefabs.GStringBox.password({
                        //        obslouzilJsemSbiraniHodnotZPolicekTakAbyNemohlNastatProblemSNeaktualnimSifrovacimKlicem: true
                        //    }), {
                        //        name: "passwd",
                        //        validators: [new Gordic.Validators.Required({ stopping: true })],
                        //    })
                        //}
                    })
                    .addDateColumn({
                        caption: "jres:29931137",
                        name: "dat_do",
                        //editor: {
                        //    widget: "gdatebox",
                        //     options: $.extend(Gordic.Prefabs.Select.gincakt(), {
                        //         validators: [new Gordic.Validators.Required({ stopping: true })]
                        //     })
                        //}
                    })
                    .addTextColumn({
                        caption: "jres:32131030",
                        name: "aktivita_txt",
                        //editor: {
                        //    widget: "gselectbox",
                        //    options: $.extend(Gordic.Prefabs.Select.gincakt(), {
                        //        model: "model.aktivita=value.aktivita;model.aktivita_txt=value.aktivita_txt",
                        //        name: "aktivita",
                        //        dropdown: true,
                        //        validators: [new Gordic.Validators.Required({ stopping: true })]
                        //    })
                        //}
                    })
            })
            //.ggridroweditor({
            //    beforeStart: (ev, info: any) => {
            //        if (this.editMode == false)
            //            ev.preventDefault();
            //        else
            //            Prefabs.GStringBox.updateChiperPublicKeys(this.gridExterniUzivatele)
            //    },
            //    beforeCommit: (ev, info) => {
            //        passwd = "";
            //        Prefabs.GStringBox.updateChiperPublicKeys(this.gridExterniUzivatele).then(() => {
            //            var data: any = {};
            //            //this.gridExterniUzivatele.findFields().gfield("model", "collect", data, {});
            //        })
            //    },
            //    save: (data, ctx) => {
            //    }
            //})
            if (this.data.externiUzivatele)
               this.gridExterniUzivatele.ggrid("setData", this.data.externiUzivatele);
        }
    }
}